import { Component, computed, inject, LOCALE_ID } from '@angular/core';
import { ConfirmationDialog } from '../../shared/ui/confirmation-dialog/confirmation-dialog';
import { CurrentUserService } from '../../services/current-user.service';
import { Router } from '@angular/router';
import { UnauthorizedService } from '../../services/unauthorized.service';

@Component({
  selector: 'app-token-expired',
  imports: [ConfirmationDialog],
  templateUrl: './token-expired.html',
  styleUrl: './token-expired.scss',
})
export class TokenExpired {
  private locale = inject(LOCALE_ID);
  private router = inject(Router);
  private unauthorizedService = inject(UnauthorizedService);

  private currentUserService = inject(CurrentUserService);
  isArabic = computed(() => this.locale.startsWith('ar'));

  redirectToLogin() {
    this.unauthorizedService.clear();
    this.router.navigate(['/login']);
    this.currentUserService.logout();
  }
}
